import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer' // 预览图片组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(ElementUI);
Vue.use(Viewer)
Vue.use(infiniteScroll);
Vue.config.productionTip = false
Vue.use(VideoPlayer)
import infiniteScroll from 'v-infinite-scroll'

// Viewer.setDefaults({
//   'inline':false,//是否直接展示
//   'button':true, //右上角按钮
//   "navbar": true, //底部缩略图
//   "title": true, //当前图片标题
//   "toolbar": true, //底部工具栏
//   "tooltip": true, //显示缩放百分比
//   "movable": true, //是否可以移动
//   "zoomable": true, //是否可以缩放
//   "rotatable": true, //是否可旋转
//   "scalable": true, //是否可翻转
//   "transition": true, //使用 CSS3 过度
//   "fullscreen": true, //播放时是否全屏
//   "keyboard": true, //是否支持键盘
//   "url": "data-source",
//   debug: true,
//   defaultOptions: {
//     zIndex: 9999
//   }
// });
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
